import { useTranslation } from "react-i18next";

type UseCheckPassword = {
    checkPassword: (password: string) => string[];
};

export type CheckPasswordSettings = {
    passwordMinLength: number;
    passwordRequiresOneUpperLetter: boolean;
    passwordRequiresOneNumber: boolean;
    passwordRequiresOneSymbol: boolean;
    passwordAllowNameParts: boolean;
};

function useCheckPassword(s: CheckPasswordSettings, name: string): UseCheckPassword {
    const { t } = useTranslation();

    function checkPass(password: string): string[] {
        if (s == null) throw "useCheckPassword: settings is null.";
        if (name == null) throw "useCheckPassword: name is null.";

        const np = [];
        if (password.length < s.passwordMinLength)
            np.push(t("Auth.Register.PasswordMinLen", { count: s.passwordMinLength }));
        if (s.passwordRequiresOneNumber && password.match(/[0-9]/g) == null)
            np.push(t("Auth.Register.PasswordNumber"));
        if (s.passwordRequiresOneUpperLetter && password.match(/[A-Z]/g) == null)
            np.push(t("Auth.Register.PasswordUppercase"));
        if (s.passwordRequiresOneSymbol && password.match(/[!@#$%&\*\+\-]/g) == null)
            np.push(t("Auth.Register.PasswordSymbol"));
        if (!s.passwordAllowNameParts) {
            let nameParts = name.toLowerCase().split(' ');
            for (let part of nameParts) {
                if (part && password.toLowerCase().includes(part)) {
                    np.push(t("Auth.Register.PasswordNameParts"));
                }
            }
        }
        return np;
    }

    return {
        checkPassword: checkPass
    };
}

export default useCheckPassword;
